<template>
  <div>
    <div>
      <label class="material-label" style="margin-bottom: 5px">{{ $t('componentList.totals') }}</label>
      <el-table
        ref="stockCorrectionList"
        v-loading="loading"
        :data="productTypes"
        border
        fit
        highlight-current-row
        style="width: 100%; margin-bottom: 10px"
        row-key="rowKey"
        :tree-props="{ children: 'subProductTypes' }"
        default-expand-all
      >
        <el-table-column :label="$t('componentList.productType')">
          <template slot-scope="scope">
            <span>{{ scope.row['productTypeDescription'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('componentList.unlined')" width="80px">
          <template slot-scope="scope">
            <span>{{ Math.ceil(scope.row['unlined']) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="80px">
          <template slot-scope="scope">
            <span>{{ scope.row['unit'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('componentList.lined')" width="80px">
          <template slot-scope="scope">
            <span>{{ Math.ceil(scope.row['lined']) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="80px">
          <template slot-scope="scope">
            <span>{{ scope.row['unit'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('componentList.total')" width="80px">
          <template slot-scope="scope">
            <span>{{ Math.ceil(scope.row['total']) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="80px">
          <template>
            <span slot-scope="scope">{{ scope.row['unit'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('componentList.amountReturn')" width="80px">
          <template slot-scope="scope">
            <span>{{ Math.ceil(scope.row['amountReturn']) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="80px">
          <template slot-scope="scope">
            <span>{{ scope.row['unit'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('planning.fabricDescription')" width="80px">
          <template slot-scope="scope">
            <span>{{ Math.ceil(scope.row['requiredFabricInMeters']) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="80px">
          <template>
            <span>{{ $t('common.meter') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('series.amountOfParcels')" width="85px">
          <template slot-scope="scope">
            <span>{{ scope.row['amountOfParcels'] }}</span>
          </template>
        </el-table-column>
        <el-table-column width="80px">
          <template slot-scope="scope">
            <span>{{ scope.row['parcelType'] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentListExtras',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    seriesProductTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      productTypes: []
    };
  },
  watch: {
    seriesProductTypes(seriesProductTypes) {
      this.setProductTypes(seriesProductTypes);
    }
  },
  methods: {
    setProductTypes(seriesProductTypes) {
      let rowCounter = 0;
      seriesProductTypes.forEach(pt => {
        const unitTranslation = this.$i18n.t('planningOption.' + pt.productTypeDescription + 'Unit');
        pt.rowKey = rowCounter++;
        pt.unit = unitTranslation;
        pt.parcelType = this.getParcelType(pt.productTypeDescription);
        pt.subProductTypes.forEach(spt => {
          spt.rowKey = rowCounter++;
          spt.unit = unitTranslation;
          spt.parcelType = pt.parcelType;
        });
        pt.productTypeDescription = this.$i18n.t('planningOption.' + pt.productTypeDescription);
      });
      this.productTypes = seriesProductTypes;
    },
    getParcelType(productType) {
      switch (productType) {
        case 'Panel':
        case 'NetCurtainRoomHigh':
        case 'CurtainRoomHigh':
          return this.$i18n.t('parcelType.hangers');
        case 'RomanBlind':
          return this.$i18n.t('parcelType.romanBlindBoxes');
        case 'Cutting':
          return this.$i18n.t('parcelType.cuttingPackagesAndRoles');
      }
    }
  }
};
</script>
